import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-fp-banner',
    imports: [RouterLink],
    templateUrl: './fp-banner.component.html',
    styleUrls: ['./fp-banner.component.scss']
})
export class FpBannerComponent {
    smoothScroll(sectionId: string) {
        const element = document.getElementById(sectionId);
        if (element) {
            const navbarHeight = 52;
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = Math.max(0, elementPosition - navbarHeight);

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
}